import React from "react";
import { ToastContainer, toast, ToastOptions } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

// Define reusable toast functions
export const showToast = {
  info: (message: string, options?: ToastOptions) =>
    toast.info(message, {
      autoClose: 3000,
      theme: "colored",
      icon: false,
      position: toast.POSITION.TOP_RIGHT,
      ...options,
    }),

  success: (message: string, options?: ToastOptions) =>
    toast.success(message, {
      autoClose: 3000,
      theme: "colored",
      icon: false,
      position: toast.POSITION.TOP_RIGHT,
      ...options,
    }),

  warning: (message: string, options?: ToastOptions) =>
    toast.warning(message, {
      autoClose: 3000,
      theme: "colored",
      icon: false,
      position: toast.POSITION.TOP_RIGHT,
      ...options,
    }),

  error: (message: string, options?: ToastOptions) =>
    toast.error(message, {
      autoClose: 3000,
      theme: "colored",
      icon: false,
      position: toast.POSITION.TOP_RIGHT,
      ...options,
    }),
};

// Toast container should be rendered **once** in the root (App.tsx or Layout)
const CustomToast = () => {
  return (
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      draggable
      pauseOnHover
      theme="colored"
    />
  );
};

export default CustomToast;
